import { merge } from 'lodash';
import { Card } from './Card';
import { Chip } from './Chip';
import { Tabs } from './Tabs';
import { Form } from './Form';
import { Menu } from './Menu';
import { Lists } from './Lists';
import { Table } from './Table';
import { Alert } from './Alert';
import { Badge } from './Badge';
import { Paper } from './Paper';
import { Dialog } from './Dialog';
import { Avatar } from './Avatar';
import { Rating } from './Rating';
import { Slider } from './Slider';
import { Buttons } from './Buttons';
import { SvgIcon } from './SvgIcon';
import { Tooltip } from './Tooltip';
import { Popover } from './Popover';
import { Pickers } from './Pickers';
import { Skeleton } from './Skeleton';
import { Backdrop } from './Backdrop';
import { Snackbar } from './Snackbar';
import { Progress } from './Progress';
import { Timeline } from './Timeline';
import { TreeView } from './TreeView';
import { Container } from './Container';
import { Accordion } from './Accordion';
import { Typography } from './Typography';
import { Pagination } from './Pagination';
import { Autocomplete } from './Autocomplete'; // ----------------------------------------------------------------------

export var ComponentsOverrides = function ComponentsOverrides(_ref) {
  var theme = _ref.theme;
  return merge(Tabs({
    theme: theme
  }), Chip({
    theme: theme
  }), Card({
    theme: theme
  }), Form({
    theme: theme
  }), Menu({
    theme: theme
  }), Badge(), Lists(), Table({
    theme: theme
  }), Paper(), Alert({
    theme: theme
  }), Rating({
    theme: theme
  }), Dialog({
    theme: theme
  }), Avatar({
    theme: theme
  }), Slider({
    theme: theme
  }), Pickers({
    theme: theme
  }), Tooltip({
    theme: theme
  }), Popover({
    theme: theme
  }), Buttons({
    theme: theme
  }), SvgIcon(), Skeleton({
    theme: theme
  }), Timeline({
    theme: theme
  }), TreeView({
    theme: theme
  }), Backdrop({
    theme: theme
  }), Snackbar(), Progress({
    theme: theme
  }), Container(), Accordion({
    theme: theme
  }), Typography(), Pagination({
    theme: theme
  }), Autocomplete({
    theme: theme
  }));
};